export const LICENSE_FETCHING = 'LICENSE_FETCHING';
export const LICENSE_FAIL = 'LICENSE_FAIL';
